import queryString from 'query-string';
import { getUpdatedField } from '../utils/helpers';
import { ACTIONS, STEPS } from './constants';
import dayjs from 'dayjs';
import isEqual from 'lodash/isEqual';

const DATE_FORMAT = 'YYYY-MM-DD';

export const initialValue = {
  currentStep: STEPS.REGIONS,
  regionsList: [],
  form: {
    additionalLodges: [],
    regions: [],
    lodges: [],
    startDate: dayjs().add(10, 'days'),
    endDate: dayjs().add(15, 'days'),
    guests: {
      adults: 2,
      children: 0,
      toddler: 0,
      baby: 0,
    },
  },
  errors: {},
  summary: {
    regions: [],
    lodges: [],
  },
};

export const availabilityReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.STEP: {
      const { step } = action.payload;

      if (state.currentStep === STEPS.DATES) {
        if (!state.form.startDate || !state.form.endDate) {
          const errors = {
            startDate: !state.form.startDate,
            endDate: !state.form.endDate,
          };
          return { ...state, errors: { ...state.errors, ...errors } };
        }
      }

      if (step === STEPS.CHECK_AVAILABILITY) {
        const {
          form: {
            lodges,
            regions,
            guests: { adults, children, toddler, baby },
            startDate,
            endDate,
          },
          summary,
        } = state;
        const values = queryString.stringify(
          {
            lodges,
            regions,
            adults,
            children,
            toddler,
            baby,
            startDate: dayjs(startDate).format(DATE_FORMAT),
            endDate: dayjs(endDate).format(DATE_FORMAT),
          },
          { arrayFormat: 'bracket' },
        );

        window.location.href = `https://availability.singita.com/search?${values}`;
        return state;
      }

      return { ...state, currentStep: step, errors: {} };
    }
    case ACTIONS.ADD_REGION: {
      const { region } = action.payload;

      if (state.form.regions.includes(region.code)) {
        return state;
      }

      return {
        ...state,
        form: { ...state.form, regions: [...state.form.regions, region.code] },
        summary: {
          ...state.summary,
          regions: [...state.summary.regions, region.name],
        },
      };
    }
    case ACTIONS.SET_FORM: {
      const { regions, lodges, regionsList } = action.payload;

      let _startDate;
      let _endDate;
      if (state.form.lodges && isEqual(state.form.lodges, ['TZG-SM'])) {
        if (
          state.form.startDate &&
          state.form.startDate.isBefore(dayjs('2024-05-16'))
        ) {
          _startDate = dayjs('2024-05-16');
          _endDate = _startDate.add(7, 'days');

          return {
            ...state,
            regionsList,
            form: {
              ...state.form,
              regions: regions,
              lodges: lodges,
              startDate: _startDate,
              endDate: _endDate,
            },
          };
        }
      }
      return {
        ...state,
        regionsList,
        form: {
          ...state.form,
          regions: regions,
          lodges: lodges,
        },
      };
    }
    case ACTIONS.UPDATE_REGIONS:
      const { region } = action.payload;
      return getUpdatedField('regions', region, state);
    case ACTIONS.UPDATE_LODGES: {
      const { lodge } = action.payload;
      const newState = getUpdatedField('lodges', lodge, state);

      let _startDate;
      let _endDate;
      if (newState.form.lodges && isEqual(newState.form.lodges, ['TZG-SM'])) {
        if (
          newState.form.startDate &&
          newState.form.startDate.isBefore(dayjs('2024-05-16'))
        ) {
          _startDate = dayjs('2024-05-16');
          _endDate = _startDate.add(7, 'days');

          return {
            ...newState,
            form: {
              ...newState.form,
              startDate: _startDate,
              endDate: _endDate,
            },
          };
        }
      }

      return { ...newState };
    }

    case ACTIONS.UPDATE_DATES:
      const {
        dates: { startDate, endDate },
      } = action.payload;

      return {
        ...state,
        form: {
          ...state.form,
          startDate: startDate,
          endDate: endDate,
        },
        errors: {},
      };
    case ACTIONS.UPDATE_GUESTS:
      const { step, key } = action.payload;
      return {
        ...state,
        form: {
          ...state.form,
          guests: {
            ...state.form.guests,
            [key]: state.form.guests[key] + step,
          },
        },
        errors: {},
      };
    case ACTIONS.RESET:
      return action.payload;
    default:
      return state;
  }
};
